import React from 'react';
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Link, withRouter} from "react-router-dom";

import './footer.css';
import Logo from "../../../assets/img/logoWhite.png";

function Footer(props) {
    const handleEmailClick = (e) => {
        if (props.location?.pathname === '/contact-us') {
            e.preventDefault();
            document.querySelector('.cu-form-side')?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    };

    const handleAddressClick = (e) => {
        e.preventDefault();
        if (props.location?.pathname === '/contact-us') {
            document.querySelector('.cu-map-section')?.scrollIntoView({behavior: 'smooth', block: 'center'});
        } else {
            props.history?.push('/contact-us');
            setTimeout(() => {
                document.querySelector('.cu-map-section')?.scrollIntoView({behavior: 'smooth', block: 'center'});
            }, 400);
        }
    };

    const handleNavClick = (e, path) => {
        if (props.location?.pathname === path) {
            e.preventDefault();
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    };
    return (
        <footer className="dl-footer">
            <div className="dl-footer-top">

                {/* Brand column */}
                <div>
                    <Link to='/'>
                        <img src={Logo}
                             style={{marginLeft: -1, width: '170px', height: '32px', marginBottom: '12px'}}
                             alt="DeccanLogic"/>
                    </Link>
                    <p className="dl-footer-tagline">
                        Bringing innovative ideas to reality — together. Custom software and AI solutions
                        for startups and growing businesses.
                    </p>
                    <div className="dl-footer-contact">
                        <a href="mailto:info@deccanlogic.com">
                            <i className="fas fa-envelope"/> info@deccanlogic.com
                        </a>
                        <a href="/contact-us" onClick={handleAddressClick}>
                            <i className="fas fa-map-marker-alt"/> Kharadi, Pune, Maharashtra
                        </a>
                    </div>
                </div>

                {/* Services column */}
                <div className="dl-footer-col">
                    <h4>Services</h4>
                    <Link to="/services/ai-capabilities"            onClick={e => handleNavClick(e, '/services/ai-capabilities')}>AI Capabilities</Link>
                    <Link to="/services/technology-partnership"     onClick={e => handleNavClick(e, '/services/technology-partnership')}>Technology Partnership</Link>
                    <Link to="/services/custom-software-development" onClick={e => handleNavClick(e, '/services/custom-software-development')}>Custom Software</Link>
                </div>

                {/* Company column */}
                <div className="dl-footer-col">
                    <h4>Company</h4>
                    <Link to="/about-us"    onClick={e => handleNavClick(e, '/about-us')}>About Us</Link>
                    <Link to="/contact-us"  onClick={e => handleNavClick(e, '/contact-us')}>Contact</Link>
                    <a href="https://linkedin.com/company/deccanlogic" target="_blank" rel="noreferrer">
                        LinkedIn
                    </a>
                </div>

            </div>

            <div className="dl-footer-bottom">
                <div className="dl-footer-copy">
                    &copy; {new Date().getFullYear()} DeccanLogic Private Limited. All rights reserved.
                </div>
                <div className="dl-footer-legal">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/terms-of-service">Terms of Service</Link>
                </div>
            </div>
        </footer>
    );
}

export default connect()(withTranslation('translations')(withRouter(Footer)));
